const BaseModule = require('_base/base')

const sumOfHeights = $els => $els.get().reduce((sum, el) => sum += el.scrollHeight, 0)
const toInt = px => parseInt(px, 10)

class ZoomedModule extends BaseModule {
  get moduleItemWidths() {
    return this.$el
      .children()
      .map((_, child) => {
        const style = getComputedStyle(child)
        const marginLeft = toInt(style.getPropertyValue('margin-left'))
        const marginRight = toInt(style.getPropertyValue('margin-right'))

        return child.scrollWidth + marginLeft + marginRight
      })
      .get()
  }

  get moduleItemHeights() {
    return this.$el
      .children()
      .map((_, child) => sumOfHeights($(child).children()))
      .get()
  }

  get moduleHeight() {
    return sumOfHeights(this.$el.children())
  }

  get isSwitcher() {
    return this.$el.is('.switcher')
  }

  get minPossibleZoom() {
    return Math.min(
      this.maxWidth / this.maxModuleItemWidth,
      this.maxHeight / this.maxModuleItemHeight
    )
  }

  resetZoom() {
    this.$el.css({
      zoom: 1,
      '-webkit-text-size-adjust': 'none',
      '--zoom': 1,
    })
  }

  preReset() {
    this.resetZoom()
  }

  preCalculate() {
    this.resetZoom()

    this.maxWidth = Math.ceil(this.$el.width())
    this.maxHeight = Math.ceil(this.$el.height())

    this.maxModuleItemWidth = Math.max(...this.moduleItemWidths)
    this.maxModuleItemHeight = this.isSwitcher ? Math.max(...this.moduleItemHeights) : this.moduleHeight
  }

  preRender() {
    this.$el.css({
      zoom: this.minPossibleZoom,
      '--zoom': this.minPossibleZoom,
      '-webkit-text-size-adjust': 'auto',
    })
  }
}

$('.is__zoomed').each((_, el) => new ZoomedModule($(el)))
